export default __webpack_public_path__ + "static/media/suitcase.38936e28.svg";